export default __webpack_public_path__ + "static/media/O-125.771d9d93.png";